var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-content',{attrs:{"code":"500","desc":'Oh~~' + _vm.$t('msg_500') + '~',"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }